import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isHalfWidth', (values, value) => {
  if (!value || value === '') return true
  return /^[ -~｡-ﾟ]*$/.test(value)
})
